module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "m-label"
  }, [_vm._v("地図")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15
    }
  }, _vm._l((_vm.markers), function(m) {
    return _c('gmap-marker', {
      key: m.id,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1), _vm._v(" "), _c('gmap-street-view-panorama', {
    staticClass: "pano",
    attrs: {
      "position": _vm.center,
      "zoom": 1
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36cb02b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Family/FamilyMap.vue
// module id = 1333
// module chunks = 0